$(document).ready(function () {
   
  $(".product-selector_block").click(function () {
    $(this)
      .closest(".product-selector_outer")
      .find(".product-selector_block")
      .removeClass("active");
    $(this).addClass("active");


    var newQty = $('[data="sub"]').find('.product-selector_block.active').attr('data-qty');
    var newOtpPrice = $('[data="otp"]').find('.product-selector_block[data-qty="'+newQty+'"]').find('.product-selector_price').html();
    $('.pp_atc-checkout-otp-price').html(newOtpPrice);
  });

  $(".pp_var_autoship").click(function () {
    $(this).toggleClass("disabled");
    if ($(".pp_var_autoship").hasClass("disabled")) {
      $('.product-selector_outer[data="sub"]').removeClass("active_block");
      $('.product-selector_outer[data="otp"]').addClass("active_block");
    } else {
      $('.product-selector_outer[data="sub"]').addClass("active_block");
      $('.product-selector_outer[data="otp"]').removeClass("active_block");
    }
  });

  $('.pp_atc-checkout-otp').click(function(){
    var mode = $(".product-selector_outer.active_block").attr("data");
    var items = [];
    var currentId  = $(".product-selector_outer.active_block").find('.product-selector_block.active').attr('data-id');
    var currentQty  = $(".product-selector_outer.active_block").find('.product-selector_block.active').attr('data-qty');
    var sellingPlan  = $(".product-selector_outer.active_block").find('.product-selector_block.active').attr('data-selling-plan');
     if (mode == "sub") {
        items.push({
            id: currentId,
            quantity: currentQty
        });
     }
     else{
        items.push({
            id: currentId,
            quantity: currentQty
        });
     }

     $(".product-selector_outer.active_block").find('.product-selector_block.active').find('.pp_selector-gift-real').each(function(){
        var currId = $(this).attr('data-id');
        var isSub = $(this).attr('data-sub');
        var currSellId = $(this).attr('data-selling-plan');
        if (isSub == 'true'){
           items.push({
              id: currId,
              quantity: 1
          });
        }
        else{
           items.push({
              id: currId,
              quantity: 1
          });
        }
       
     });

     console.log(items, 'ITEMS');

     $.ajax({
        type: "POST",
        url: "/cart/clear.js",
        dataType: "json",
        success: function () {
            $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: { items: items },
            dataType: "json",
            success: function () {
                window.location.href = '/checkout';
            },
            error: function () {
                alert("Error adding item to the cart.");
            }
            });

        },
        error: function () {
            
        }
    });
     
  });

  $('.pp_atc-checkout').click(function(){
    var mode = $(".product-selector_outer.active_block").attr("data");
    var items = [];
    var currentId  = $(".product-selector_outer.active_block").find('.product-selector_block.active').attr('data-id');
    var currentQty  = $(".product-selector_outer.active_block").find('.product-selector_block.active').attr('data-qty');
    var sellingPlan  = $(".product-selector_outer.active_block").find('.product-selector_block.active').attr('data-selling-plan');
     if (mode == "sub") {
        items.push({
            id: currentId,
            quantity: currentQty,
            selling_plan: sellingPlan
        });
     }
     else{
        items.push({
            id: currentId,
            quantity: currentQty
        });
     }

     $(".product-selector_outer.active_block").find('.product-selector_block.active').find('.pp_selector-gift-real').each(function(){
        var currId = $(this).attr('data-id');
        var isSub = $(this).attr('data-sub');
        var currSellId = $(this).attr('data-selling-plan');
        if (isSub == 'true'){
           items.push({
              id: currId,
              quantity: 1,
              selling_plan: currSellId
          });
        }
        else{
           items.push({
              id: currId,
              quantity: 1
          });
        }
       
     });

     console.log(items, 'ITEMS');

     $.ajax({
        type: "POST",
        url: "/cart/clear.js",
        dataType: "json",
        success: function () {
            $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: { items: items },
            dataType: "json",
            success: function () {
                window.location.href = '/checkout';
            },
            error: function () {
                alert("Error adding item to the cart.");
            }
            });

        },
        error: function () {
            
        }
    });
     
  });

  $(".product-selector_atc").click(function () {
    if ($(this).attr("data-mode-champs") == "true") {
      var newUrl = $(".product-selector_outer.active_block")
        .find(".product-selector_block.active")
        .attr("data-champs-url");

      window.location.href = newUrl;
    } else {
      var currentId = $(".product-selector_outer.active_block")
        .find(".product-selector_block.active")
        .attr("data-id");
      var mode = $(".product-selector_outer.active_block").attr("data");
      var currentSellingPlan = $(".product-selector_outer.active_block")
        .find(".product-selector_block.active")
        .attr("data-selling-plan");
      if (mode == "sub") {
        data = {
          id: currentId,
          quantity: 1,
          selling_plan: currentSellingPlan,
        };
      } else {
        data = {
          id: currentId,
          quantity: 1,
        };
      }

      console.log(data);

      jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        dataType: "json",
        success: function () {},
        error: function () {
          // alert("Error adding item to the cart.");
        },
      });
    }
  });
});
